import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { RevelationSection } from './components/RevelationSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ContrastSection } from './components/ContrastSection';
import { AuthoritySection } from './components/AuthoritySection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { Divider } from './components/ui/Divider';
import { initMetaPixel, trackEvent } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-brown selection:bg-gold/30 selection:text-brown-dark" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <IdentificationSection data-id="element-3" />

        <div className="bg-white" data-id="element-4">
          <Divider data-id="element-5" />
        </div>

        <RevelationSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <ContrastSection data-id="element-9" />
        <AuthoritySection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}